export default __webpack_public_path__ + "static/media/918.ba6648c8.png";